import { render, staticRenderFns } from "./VacationRequest.vue?vue&type=template&id=31b23270&scoped=true&"
import script from "./VacationRequest.vue?vue&type=script&lang=ts&"
export * from "./VacationRequest.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31b23270",
  null
  
)

export default component.exports